var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.193852 5.51566C0.19457 5.62861 0.229603 5.73868 0.294307 5.83128C0.359011 5.92387 0.45033 5.9946 0.556155 6.03411L5.95267 8.05241L8.21346 13.3525C8.25714 13.455 8.33055 13.542 8.42421 13.6024C8.51787 13.6628 8.62748 13.6937 8.73888 13.6911L8.74779 13.6909C8.86057 13.6866 8.96937 13.6481 9.0598 13.5806C9.15022 13.513 9.21801 13.4196 9.25418 13.3127L13.4326 0.957111C13.4668 0.856591 13.4716 0.748385 13.4464 0.645238C13.4211 0.542091 13.367 0.448298 13.2902 0.374905C13.2135 0.301512 13.1174 0.251575 13.0132 0.230976C12.9091 0.210377 12.8012 0.219974 12.7023 0.258635L0.548708 4.99266C0.443507 5.03374 0.353257 5.10579 0.289896 5.19927C0.226534 5.29276 0.193047 5.40328 0.193865 5.51622L0.193852 5.51566Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.0c4393cdd3e31c7b5346f4895b8a777e.svg";
export { ForwardRef as ReactComponent };